import { ISelectedItem } from '../../../components/Inputs/Selects/MultiSelectCheck';
import { ListadoItem } from '../../../interfaces/Indicator';
import { IOptions } from '../../../interfaces/Rights';
import { ChartTypeValue, isChartType } from '../../../utils/chartTypes'
import { INDICATOR_TYPE_PROCESS, INDICATOR_TYPE_RESULTS } from '../../../utils/const';
import { normalizeString } from '../../../utils/utils';

export const getChartTypeValue = (value: any): ChartTypeValue | undefined => {
    return isChartType(value) ? Number(value) as ChartTypeValue : undefined;
};

export const getEjeY2Config = (chart?: any) => {
    if (!chart?.eje_y2 || !chart?.eje_y2_data) {
        return { type: undefined, variable: '' };
    }

    return {
        type: getChartTypeValue(chart.eje_y2_data.type_of_graph),
        variable: chart.eje_y2_data.variable_analisis ?? ''
    };
};

export const getSearchPredicate = (typeOfIndicador: string = INDICATOR_TYPE_RESULTS, variable_analisis: string[]) => {
    return (key: string) => {
        const lowerKey = key.toLowerCase();

        return variable_analisis.some(varAnalisis => lowerKey.includes(varAnalisis.toLowerCase()));
    };
};

export const filterDataKeyByAnalysisVariables = <T extends { key: string }>(
    dataKey: T[] | undefined,
    typeOfIndicador: string,
    variable_analisis: string[]
): T[] | undefined => {
    if (!dataKey) return dataKey;

    return dataKey.filter((key) => {
        if (typeOfIndicador !== INDICATOR_TYPE_PROCESS) {
            return true;
        }

        const normalizedKey = normalizeString(key.key);

        const matches = variable_analisis.some(variable => {
            const normalizedVariable = normalizeString(variable);
            return normalizedKey === normalizedVariable;
        });

        return matches;
    });
};

export function calculateValuesFromDataFormated(dataFormated: any[], variableAnalisis: string[]): any[] {
    const calculatedValues: any = [];

    dataFormated.forEach((data) => {
        const { name, ...variables } = data;
        const calculatedForYear: any = { name };

        variableAnalisis.forEach((variable) => {
            Object.keys(variables).forEach((key) => {
                if (key.includes(variable) && key !== variable) {
                    const valueParts = key.split('-').find((part) => part.includes(variable))?.split(':');

                    if (valueParts && valueParts.length === 2) {
                        const variableValue = valueParts[1]?.trim();
                        if (variableValue) {
                            if (!calculatedForYear[variableValue]) {
                                calculatedForYear[variableValue] = 0;
                            }
                            calculatedForYear[variableValue] += Number(parseFloat(variables[key]).toFixed(3));
                        }
                    }
                } else if (key === variable) {
                    calculatedForYear[variable] = Number(parseFloat(variables[key]).toFixed(3));
                }
            });
        });

        calculatedValues.push(calculatedForYear);
    });

    return calculatedValues;
}

//Modificamos la información del gráfico
export function getDataForGraph(valores: any[]): any[] {
    const groupedByYear = valores.reduce((acc, valor) => {
        const { anio, encabezado, valor: valorNum } = valor;
        if (!acc[anio]) acc[anio] = { name: anio };

        const variablePath = encabezado.split('-').map((part: any) => part.replace('.', ':')).join(' - ');
        acc[anio][variablePath] = valorNum;

        return acc;
    }, {});

    return Object.values(groupedByYear);
}

// Agrega o quita un item de la lista. Los strings se comparan directo, los objetos por `value`
export function toggleSelected<T extends string | { value: unknown }>(
    arr: T[],
    item: T
): T[] {
    const keyOf = (i: string | { value: unknown }) => (typeof i === "string" ? i : i.value);
    return arr.some(i => keyOf(i) === keyOf(item))
        ? arr.filter(i => keyOf(i) !== keyOf(item))
        : [...arr, item];
}

export const findSelected = (selected: ISelectedItem[], source: IOptions[]) => {
    const objs = source.filter((item) => selected.some((s) => s.value === item.value));
    const ids = objs.map((obj) => obj.id.toString());
    return { objs, ids };
};

/**
 * Determina si una capa está vigente para un año dado.
 * - fecha_alta: año desde el que la capa existe (inclusive)
 * - fecha_baja: año hasta el que existe (inclusive). Si es null, sin límite superior.
 */
export const isLayerActiveForYear = (item: ListadoItem, year: string | null): boolean => {
    if (!year) return false;

    const yearNum = Number(year);
    if (Number.isNaN(yearNum)) return false;

    if (!item.fecha_alta) return false;
    const altaYear = Number(item.fecha_alta);
    if (Number.isNaN(altaYear)) return false;

    if (yearNum < altaYear) return false;

    if (!item.fecha_baja) return true;
    const bajaYear = Number(item.fecha_baja);
    if (Number.isNaN(bajaYear)) return true;

    return yearNum <= bajaYear;
};